// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__-rWNe","paramInput":"JobSimulator_paramInput__2jKnM","input":"JobSimulator_input__16J6a"};